// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBDoKF5_9kr5Pmdvqpiw80pZfAZZ8GaD6g",
  authDomain: "art-fluence-customise-project.firebaseapp.com",
  projectId: "art-fluence-customise-project",
  storageBucket: "art-fluence-customise-project.firebasestorage.app",
  messagingSenderId: "257291570511",
  appId: "1:257291570511:web:7c9f9dff6938299f52893a",
  measurementId: "G-GRB3YNYDZK"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
